import { render, staticRenderFns } from "./FspAcknowledgeFormLegacyView.vue?vue&type=template&id=7a0b86d1&"
import script from "./FspAcknowledgeFormLegacyView.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormLegacyView.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormLegacyView.vue?vue&type=style&index=0&id=7a0b86d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports